import { defineStore } from 'pinia'
import {
  getUserInfo,
  hasBlockDoorPermission,
  getProjectOverview,
  getUserProject,
  getPushSwitch
} from '@/apis/login/koneOnline'
import { IUserInfo, IProjectOverview, UserProjectConfig } from '@/apis/types/koneOnline'
import { OnlinePermission } from '@/apis/types/userMgr'
import { persistEncryption } from '../plugin/persist'
import { permissionApi } from '@/apis/auth'

export const useKOLInfoStore = defineStore('koneOnlineInfo', {
  state: () => ({
    permissions: [] as OnlinePermission[],
    userInfo: undefined as IUserInfo | undefined,
    hasLadderStopEvent: false,
    alarmNotificationSwitch: true,
    elevatorStopNotificationVoiceSwitch: true,
    elevatorStopNotificationSwitch: true,
    projectOverview: undefined as IProjectOverview | undefined,
    userProjectConfig: undefined,
    externalId: undefined as string | undefined,
    loaded: false
  }),
  getters: {
    getPermissions(state): OnlinePermission[] {
      return state.permissions
    },
    getUserInfo(state): IUserInfo | undefined {
      return state.userInfo
    },
    getHasLadderStopEvent(state): boolean {
      return state.hasLadderStopEvent
    },
    getAlarmNotificationSwitch(state): boolean {
      return state.alarmNotificationSwitch
    },
    getElevatorStopNotificationSwitch(state): boolean {
      return state.elevatorStopNotificationSwitch
    },
    getElevatorStopNotificationVoiceSwitch(state): boolean {
      return state.elevatorStopNotificationVoiceSwitch
    },
    getProjectOverview(state): IProjectOverview | undefined {
      return state.projectOverview
    },
    getUserProjectConfig(state): UserProjectConfig | undefined {
      return state.userProjectConfig
    },
    getExternalId(state): string | undefined {
      return state.externalId
    },
    getAll(state) {
      return {
        permissions: state.permissions,
        userInfo: state.userInfo,
        hasLadderStopEvent: state.hasLadderStopEvent,
        alarmNotificationSwitch: state.alarmNotificationSwitch,
        elevatorStopNotificationVoiceSwitch: state.elevatorStopNotificationVoiceSwitch,
        elevatorStopNotificationSwitch: state.elevatorStopNotificationSwitch,
        projectOverview: state.projectOverview,
        userProjectConfig: state.userProjectConfig,
        externalId: state.externalId
      }
    },
    getLoaded(state): boolean {
      return state.loaded
    }
  },
  actions: {
    async init(permissionInput: OnlinePermission[]) {
      if (permissionInput.length > 0) {
        this.permissions = permissionInput
        localStorage.setItem(
          'kolPermission',
          persistEncryption.encrypt(JSON.stringify(permissionInput))
        )
      } else {
        // 刷新页面时，重新获取权限信息
        const res = await permissionApi({})
        this.permissions = res.permissions
        localStorage.setItem(
          'kolPermission',
          persistEncryption.encrypt(JSON.stringify(res.permissions))
        )
      }
      try {
        const [userInfo, hasPermission, projectOverview, userProject, pushSwitch] =
          await Promise.all([
            getUserInfo(),
            hasBlockDoorPermission(),
            getProjectOverview(),
            getUserProject(),
            getPushSwitch()
          ])
        this.userInfo = userInfo
        this.hasLadderStopEvent = hasPermission
        this.projectOverview = projectOverview
        this.userProjectConfig = userProject
        this.alarmNotificationSwitch = pushSwitch.alarmNotificationSwitch
        this.elevatorStopNotificationVoiceSwitch = pushSwitch.elevatorStopNotificationVoiceSwitch
        this.elevatorStopNotificationSwitch = pushSwitch.elevatorStopNotificationSwitch
        // console.log('======init koneOnlineInfo======\n', this.getAll)
        localStorage.setItem(
          'kolInfo',
          persistEncryption.encrypt(
            JSON.stringify({
              permissions: this.permissions,
              userInfo,
              hasLadderStopEvent: hasPermission,
              projectOverview,
              userProjectConfig: userProject,
              alarmNotificationSwitch: pushSwitch.alarmNotificationSwitch,
              elevatorStopNotificationVoiceSwitch: pushSwitch.elevatorStopNotificationVoiceSwitch,
              elevatorStopNotificationSwitch: pushSwitch.elevatorStopNotificationSwitch
            })
          )
        )
      } catch (error) {
        console.log(error)
      }
    },
    logout() {
      localStorage.removeItem('kolInfo')
      localStorage.removeItem('kolPermission')
      this.$reset()
    }
  }
})

export function getLocalKolInfo() {
  return JSON.parse(persistEncryption.decrypt(localStorage.getItem('kolInfo') ?? '') || '{}')
}
